import { render, staticRenderFns } from "./ChannelNotificationConfig.vue?vue&type=template&id=d47d26e0&scoped=true"
import script from "./ChannelNotificationConfig.vue?vue&type=script&lang=js"
export * from "./ChannelNotificationConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47d26e0",
  null
  
)

export default component.exports